/**
 * View Registry — maps server-emitted view names to React components.
 *
 * The agent calls show_view({ view: "<name>", data: {...} }); the canvas
 * looks up <name> in this map and renders it with `data` as a prop.
 *
 * Adding a new view type:
 *   1. Create the component under views/<YourView>.jsx
 *   2. Import here + register under a stable string name
 *   3. Update the runtime's form-filler-agent.js prompt (or the
 *      relevant agent) so the LLM knows the name exists
 *
 * Every registered component receives:
 *   - data   : whatever the agent passed in show_view/update_view
 *   - onAction(action): callback to emit user-triggered actions up
 *                       to the workspace session. Action shape is
 *                       component-specific; the session forwards it
 *                       to the server as { type:"client_action", payload: action }.
 */

import ReferralForm from "./views/ReferralForm.jsx";
import SubmittedConfirmation from "./views/SubmittedConfirmation.jsx";

export const VIEW_REGISTRY = {
  referral_form: ReferralForm,
  submitted_confirmation: SubmittedConfirmation,
};

export function getViewComponent(name) {
  return VIEW_REGISTRY[name] || null;
}
